import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";
import { map } from "rxjs/operators";
import { ApiOrganisationConstants } from "../../shared/constants/api-constants/api-organisation.constants";
import { ApiModuleTemplateConstants } from "../../shared/constants/api-constants/api-module-template.constants";
import { ApiUserConstants } from "../../shared/constants/api-constants/api-user.constants";
import { ApiOrganisationSettingsConstants } from "../../shared/constants/api-constants/api-organisation-settings.constants";
import { ApiAdminConstants } from "../../shared/constants/api-constants/api-admin.constants";
import { ApiModuleConstants } from "src/app/shared/constants/api-constants/api-module.constants";
let OrganisationSettingsService = class OrganisationSettingsService {
    http;
    moduleTemplatesSubject = new BehaviorSubject([]);
    moduleTemplates$ = this.moduleTemplatesSubject.asObservable();
    organisation;
    organisationUrl = ApiOrganisationConstants.URL;
    moduleTemplateUrl = ApiModuleTemplateConstants.URL;
    usersUrl = ApiUserConstants.URL;
    constructor(http) {
        this.http = http;
    }
    getOrganisations() {
        return this.http.get(`${this.organisationUrl}`);
    }
    getOrganisationDetails(organisationId) {
        const params = {
            $expand: `logo`
        };
        return this.http.get(`${this.organisationUrl}/${organisationId}`, { params });
    }
    getIsClassicWorkflow() {
        return this.http.get(`${ApiAdminConstants.URL}/${ApiAdminConstants.FUNCTION_IS_CLASSIC_WORKFLOW}`);
    }
    suspendOrganisation(organisationId) {
        return this.http.post(`${this.organisationUrl}/${organisationId}/SuspendOrganisation`, {
            suspended: true
        });
    }
    updateOrganisation(organisationId, organisationData) {
        return this.http.patch(`${this.organisationUrl}/${organisationId}`, organisationData);
    }
    reinstateOrganisation(organisationId) {
        return this.http.post(`${this.organisationUrl}/${organisationId}/ReinstateOrganisation`, {
            suspended: false
        });
    }
    getModuleTemplates() {
        return this.http.get(this.moduleTemplateUrl).pipe(map(moduleTemplates => {
            this.moduleTemplatesSubject.next(moduleTemplates.value);
            return moduleTemplates.value;
        }));
    }
    getModalOptions(modalSize) {
        return { size: modalSize, centered: true, keyboard: false, backdrop: "static" };
    }
    suspendUser(userId, organisationId) {
        return this.http.post(`${this.organisationUrl}/${organisationId}/SuspendUserFromOrganisation`, {
            userId
        });
    }
    unSuspendUser(userId, organisationId) {
        return this.http.post(`${this.organisationUrl}/${organisationId}/UnsuspendUserFromOrganisation`, {
            userId
        });
    }
    acceptApplication(userId, organisationId) {
        return this.http.post(`${ApiOrganisationConstants.URL}/${organisationId}/${ApiOrganisationConstants.FUNCTION_ACCEPT_APPLICATION}`, { userId });
    }
    rejectApplication(userId, organisationId) {
        return this.http.post(`${ApiOrganisationConstants.URL}/${organisationId}/${ApiOrganisationConstants.FUNCTION_REJECT_APPLICATION}`, { userId });
    }
    getUserDetails(organisationId, userId) {
        const params = {
            $expand: `organisations($expand=modules($expand=userModuleRoles),userSystemRoles;$filter=id eq ${organisationId})`
        };
        return this.http.get(`${this.usersUrl}/${userId}`, { params });
    }
    removeUsersFromOrganisation(organisationId, deletedUserIds) {
        return this.http.post(`${this.organisationUrl}/${organisationId}/RemoveUsersFromOrganisation`, {
            ids: deletedUserIds
        });
    }
    removeUserFromOrganisation(organisationId, deletedUserId) {
        return this.http.post(`${this.organisationUrl}/${organisationId}/RemoveUserFromOrganisation`, {
            userId: deletedUserId
        });
    }
    uploadOrganizationLogo(logo, organisationId) {
        return this.http.post(`${this.organisationUrl}/${organisationId}/${ApiOrganisationConstants.FUNCTION_UPLOAD_LOGO}`, logo);
    }
    getDownloadLogo(attachmentId) {
        return this.http.get(`${ApiOrganisationConstants.URL}/${attachmentId}/${ApiOrganisationConstants.FUNCTION_DOWNLOAD_LOGO}`, { responseType: "blob" });
    }
    getOrganisationSettings(settingsId) {
        return this.http.get(`${ApiOrganisationSettingsConstants.URL}/${settingsId}`);
    }
    patchOrganisationSettings(settingsId, settingsData) {
        return this.http.patch(`${ApiOrganisationSettingsConstants.URL}/${settingsId}`, settingsData);
    }
    getHelpFile(moduleId) {
        const url = `${ApiModuleConstants.URL}/${moduleId}/${ApiModuleConstants.FUNCTION_GET_HELP_FILE}`;
        return this.http.get(url, { responseType: "blob" });
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
OrganisationSettingsService = __decorate([
    Injectable({
        providedIn: "root"
    })
], OrganisationSettingsService);
export { OrganisationSettingsService };
